<template>
  <main class="container">
      <div class="notFound">
        <h1>Vi hittar inte det du söker!</h1>
      </div>
  </main>
</template>

<script>

export default {
    name:"NotFound"
}

</script>

<style scoped>
.notFound{
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;

}


</style>